import type { FunctionComponent } from 'react';
import { ReactComponent as AvatarSVG } from '../images/avatar.svg';
import * as styles from './ProfileImage.module.css';

type ProfileImageProps = {
  avatarUrl: string | null;
  openFileDialog: () => void;
};

const ProfileImage: FunctionComponent<ProfileImageProps> = ({ avatarUrl, openFileDialog }) => {
  return (
    <button type="button" className={styles.imageContainer} onClick={openFileDialog}>
      <div className={styles.profileImage} data-testid="profile-image-container">
        {avatarUrl ? <img src={avatarUrl} alt="user profile icon" /> : <AvatarSVG />}
      </div>
      <div className={styles.camera}>
        <i className="fas fa-camera-alt" />
      </div>
    </button>
  );
};
export default ProfileImage;
